import {
	getQuestionnaireInitialValues,
	Questionnaire,
	type QuestionnaireFormValues,
} from "@sveabank/cc-common";
import { usePageContext } from "../../../hooks/context";
import { useKyc } from "../hooks";

type Props = {
	onSubmit: (values: QuestionnaireFormValues) => Promise<void>;
};

const ApplicationQuestions = ({ onSubmit }: Props) => {
	const { applicationQuestions, allCountries } = usePageContext(useKyc);
	const initialValues = getQuestionnaireInitialValues(applicationQuestions);

	return (
		<Questionnaire
			onSubmit={onSubmit}
			questions={applicationQuestions}
			initialValues={initialValues}
			allCountries={allCountries}
		/>
	);
};
export default ApplicationQuestions;
